import React from 'react';
import { Badge } from 'antd';
import './Badge.less';

export type BadgeProps = {
  statusText?: string;
  status?: 'success' | 'processing' | 'error' | 'default' | 'warning';
  count?: Number;
  size?: 'default' | 'small';
  type?: 'default' | 'reverse';
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TBadge: React.FC<BadgeProps> = ({ statusText, type, ...props }) => {
  const classNames = ['badge-container', `badge-container-${type}`];

  return (
    <div className={classNames.join(' ')}>
      <Badge text={statusText} {...props} />
    </div>
  );
};

export default TBadge;
